import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import http from "../../services/HttpService";
import config from "../../config.json";
import BprmForm from "../../comman/BprmForm";

class SubForm extends BprmForm {
  constructor(props) {
    super(props);
    this.state = {
      htmlJsonString: [
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "ASD",
              id: "asd",
              isRequired: false,
              dataType: "textBox",
              attributeType: "Subformtest",
              validation: {},
              attributeObject: "Textbox",
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "VVF",
              id: "vvf",
              isRequired: true,
              dataType: "multiLineBox",
              attributeType: "Subformtest",
              validation: {
                encryptionValidate: true,
              },
              attributeObject: "Multiline",
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "FGGH",
              dataType: "radio",
              id: "fggh",
              radioValues: [
                {
                  name: "VFE",
                  value: "first",
                },
                {
                  name: "DDE",
                  value: "",
                },
              ],
              attributeType: "Subformtest",
              validation: {},
              isRequired: true,
              attributeObject: "Radio",
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "VVFFD",
              id: "vvffd",
              isRequired: true,
              dataType: "textBox",
              attributeType: "Subformtest",
              validation: {},
              attributeObject: "Phone",
            },
          ],
        },
        {
          label: "?  Column",
          dataType: "column",
          id: "column",
          width: 6,
          components: [
            {
              label: "Save And Continue",
              id: "button",
              dataType: "button",
              navigationPage: "",
              style: "btn btn-outline-default",
              buttonType: {
                type: "saveAndContinue",
                name: "Save And Continue",
              },
            },
          ],
        },
      ],
      aWorkfinityAppEntity: {},
      wfForm: {},
      data: {},
      errors: {},
      encryptionDecryptions: {},
      //rules: [],
    };
  }

  schema = {};

  async componentDidMount() {
    const { subFormId, aWorkfinityAppEntity } = this.props;
    //console.log(aWorkfinityAppEntity);
    const { data: wfForm } = await http.get(config.GetForm + subFormId);

    // console.log(wfForm);
    this.setState({ wfForm });
    // if (wfForm) {
    //   const formData = aWorkfinityAppEntity[wfForm.formName.toLowerCase()];
    //   this.setState({ data: formData });
    // }
  }

  render() {
    const { wfForm, htmlJsonString } = this.state;
    const elements = //htmlJsonString;
      wfForm.elementJson != undefined && JSON.parse(wfForm.elementJson);
    const { showHide, handleModalShowHide, title, subFormId } = this.props;
    return (
      <Modal show={showHide} size={"lg"}>
        <Modal.Header
          closeButton
          onClick={() => handleModalShowHide("showHide" + subFormId)}
        >
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {elements &&
              elements.map((col) => (
                <div className={`col-` + col.width}>
                  {col.components.map((comp) => {
                    return this.rendorHtmlComponent(comp);
                  })}
                </div>
              ))}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => handleModalShowHide("showHide" + subFormId)}
          >
            Close
          </Button>
          <Button variant="primary" onClick={this.doSubmit}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    );
  }
}

export default SubForm;
